export interface McGovernColorGroup {
  [key: string]: string;
}

// Color schema - source of truth (figma)
export class McGovernColorPalette {
  colors: { [groupName: string]: McGovernColorGroup };

  constructor() {
    this.colors = {};
    this.addColorGroup('brand', {
      mcGovernTeal: '#007D99', // Primary
      mcGovernGold: '#FFC719', // Primary
      mcGovernRust: '#DE8B39', // Secondary
      mcGovernLime: '#C2CE51', // Secondary
      mcGovernPeacock: '#438C8B', // Secondary
      mcGovernDarkTeal: '#005771', // Secondary
      mcGovernMediumTeal: '#7FAFC3', // Secondary
      mcGovernCaramel: '#E1BC7C', // Secondary
      mcGovernPine: '#79A27A', // Secondary
      mcGovernMediumGray: '#A7A9AC', // Background
      mcGovernLightTeal: '#CBDCE1', // Background
      mcGovernLightLime: '#EEF2C2', // Background
      mcGovernLightGold: '#FAE6BB', // Background
      mcGovernLightPine: '#C4D2C3', // Background
      mcGovernLightGray: '#E6E7E8', // Background
    });

    this.addColorGroup('neutral', {
      black: '#231F20',
      white: '#FFFFFF',
      tailwind50: '#FAFAFA',
      tailwind100: '#F5F5F5',
      tailwind200: '#E5E5E5',
      tailwind300: '#D4D4D4',
      tailwind400: '#A3A3A3',
      tailwind500: '#737373',
      tailwind600: '#525252',
      tailwind700: '#404040',
      tailwind800: '#262626',
      tailwind900: '#171717',
      tailwind950: '#0A0A0A',
    });

    this.addColorGroup('system', {
      successGreen: '#22C55E',
      successGreenLight: '#F0FDF4',
      successGreenDark: '#137A39',
      errorRed: '#F43F5E',
      errorRedLight: '#FFF1F2',
      errorRedDark: '#9C2439',
      warningYellow: '#FACC15',
      warningYellowLight: '#FEFCE8',
      warningYellowDark: '#B29008',
      infoBlue: '#1893d5',
      infoBlueLight: '#e5f6fd',
      infoBlueDark: '#105175',
    });

    this.addColorGroup('semantic', {
      backgroundPrimary: this.colors.neutral.white,
      backgroundSecondary: this.colors.neutral.tailwind100,
      backgroundTertiary: this.colors.neutral.tailwind300,
      backgroundAlternate: this.colors.neutral.black,
      backgroundSuccess: this.colors.system.successGreenLight,
      backgroundError: this.colors.system.successRedLight,
      borderPrimary: this.colors.neutral.black,
      borderSecondary: this.colors.neutral.tailwind300,
      borderTertiary: this.colors.neutral.tailwind500,
      borderAlternate: this.colors.brand.mcGovernTeal,
      borderSuccess: this.colors.system.successGreen,
      borderError: this.colors.system.successRed,
      textPrimary: this.colors.neutral.black,
      textSecondary: this.colors.neutral.tailwind800,
      textAlternate: this.colors.neutral.tailwind700,
      textSuccess: this.colors.system.successGreen,
      textError: this.colors.system.successRed,
      linkPrimary: this.colors.neutral.black,
      linkSecondary: this.colors.neutral.tailwind800,
      linkAlternate: this.colors.neutral.tailwind700,
    });
  }

  addColorGroup(groupName: string, colors: McGovernColorGroup) {
    this.colors[groupName] = colors;
  }

  getColor(groupName: string, colorName: string) {
    return this.colors[groupName][colorName];
  }
}

const colorPalette = new McGovernColorPalette();
export const brandColors: McGovernColorGroup = colorPalette.colors.brand;
export const neutralColors: McGovernColorGroup = colorPalette.colors.neutral;
export const systemColors: McGovernColorGroup = colorPalette.colors.system;
export const semanticColors: McGovernColorGroup = colorPalette.colors.semantic;
